import type { Experience } from "@inter-ikea-space-platform/experience";
import { KnobsAndHandles } from "@inter-ikea-space-platform/range";

export const knobsAndHandles = (): Experience => KnobsAndHandles();
